import { CampaignFilter, CampaignFragment } from '@occc/graphql';
import { useGetCampaignsLazy } from '@occc-app/dataAccessLayer/campaign/queries';

import { CampaignSelectItem } from './campaign-select.types';

export const mapCampaignsQueryResponseToRawArray = (
  response: ReturnType<typeof useGetCampaignsLazy>['response'],
): CampaignSelectItem[] =>
  response.data ? response.data.map(({ uuid, name }) => ({ uuid, name })) : [];

export const mapRawCampaignResponseItemToAutocompleteOption = (item: CampaignFragment) => ({
  value: item.uuid,
  label: item.name,
  _raw: item,
});

export const makeCampaignsFilter =
  (chainId: string) =>
  (search: string): CampaignFilter => {
    const trimmed = search.trim();
    return {
      deleted: false,
      chainIdEquals: chainId,
      search: trimmed ? trimmed : undefined,
    };
  };
